package diana.soleil.design.iraniancanadienbazzar.feature.orders

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppConfirmDialog
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.QuantityStepper
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeader
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SettingsToggleRow
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.StatusBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.model.CartItem
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCount
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_time_just_now
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_time_minutes_ago
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_time_hours_ago
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_time_days_ago
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_time_weeks_ago
import kotlin.math.roundToLong
import kotlin.time.Clock
import diana.soleil.design.iraniancanadienbazzar.core.model.Order
import diana.soleil.design.iraniancanadienbazzar.core.model.OrderStatus
import diana.soleil.design.iraniancanadienbazzar.core.model.PaymentStatus
import diana.soleil.design.iraniancanadienbazzar.core.model.Product
import diana.soleil.design.iraniancanadienbazzar.core.model.PropertyDetails
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCadCents
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_add_to_cart
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_added
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_cancel_confirm_message
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_cancel_failed
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_cancel_keep
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_cancel_order
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_accept
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_cancel_message
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_error
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_failed
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_fulfill
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_note
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_paid
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_retry
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mo_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_cart_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_cart_remove_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_cart_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_cart_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_checkout_cta
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_checkout_failed
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_checkout_note_label
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_checkout_pickup_note
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_checkout_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_confirm_desc
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_confirm_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_error
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_history_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_history_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_history_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_add
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_available
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_name_en
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_name_fa
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_price
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_mark_promoted
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_promoted
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_promoted_desc
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_promoted_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_remove_promotion
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_mp_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_product_image_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_products_section_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_promotions_section_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_pay_at_pickup
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_proceed_checkout
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_qty_line
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_prop_toggle_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_prop_toggle_desc
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_prop_bedrooms
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_prop_bathrooms
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_prop_area
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_prop_address
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_prop_beds_short
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_prop_baths_short
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_prop_sqft_short
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.orders_product_save_failed
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_replace_cart_warning
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_replace_cart_title
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_replace_cart_confirm
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_replace_cart_cancel
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_retry
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_status_cancelled
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_status_confirmed
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_status_fulfilled
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_status_pending
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_subtotal
import diana.soleil.design.iraniancanadienbazzar.feature.orders.resources.ord_view_orders
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

// ---------- Product detail (Stitch dd9128c2 — deviations: no related-products carousel yet) ----------

@Composable
fun ProductDetailRoute(
    businessId: String,
    productId: String,
    onBack: () -> Unit,
    onOpenCart: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: ProductDetailViewModel = koinViewModel(parameters = { parametersOf(businessId, productId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val language = AppTheme.language
    ProductDetailScreen(
        state = state,
        onBack = onBack,
        onQuantity = viewModel::setQuantity,
        onAddToCart = { viewModel.addToCart(language) },
        onOpenCart = onOpenCart,
        modifier = modifier,
    )
}

@Composable
fun ProductDetailScreen(
    state: ProductDetailUiState,
    onBack: () -> Unit,
    onQuantity: (Int) -> Unit,
    onAddToCart: () -> Unit,
    onOpenCart: () -> Unit,
    modifier: Modifier = Modifier,
) {
    // Confirm before wiping a cart that belongs to another business (was a silent replace).
    var showReplaceConfirm by remember { mutableStateOf(false) }
    if (showReplaceConfirm) {
        AppConfirmDialog(
            title = stringResource(Res.string.ord_replace_cart_title),
            message = stringResource(Res.string.ord_replace_cart_warning),
            confirmLabel = stringResource(Res.string.ord_replace_cart_confirm),
            cancelLabel = stringResource(Res.string.ord_replace_cart_cancel),
            destructive = true,
            onConfirm = { showReplaceConfirm = false; onAddToCart() },
            onDismiss = { showReplaceConfirm = false },
        )
    }
    when {
        state.loading -> { LoadingState(modifier = modifier.fillMaxSize()); return }
        state.error || state.product == null -> {
            ErrorState(
                message = stringResource(Res.string.ord_error),
                onRetry = onBack,
                retryLabel = stringResource(Res.string.ord_retry),
                modifier = modifier,
            )
            return
        }
    }
    val product = state.product
    val language = AppTheme.language
    Column(modifier = modifier.fillMaxHeight().background(AppTheme.colors.background).appContentWidth(AppTheme.sizes.contentMaxWidth)) {
        Column(
            modifier = Modifier.weight(1f).verticalScroll(rememberScrollState()),
        ) {
            Box(modifier = Modifier.fillMaxWidth().aspectRatio(16f / 9f).clip(AppTheme.shapes.card)) {
                BusinessCover(imageUrl = product.imageUrl, iconName = "sell")
                AppIconButton(
                    iconName = "arrow_back",
                    contentDescription = stringResource(Res.string.ord_back_a11y),
                    onClick = onBack,
                    modifier = Modifier
                        .statusBarsPadding().navigationBarsPadding()
                        .padding(AppTheme.spacing.md)
                        .background(AppTheme.colors.surface, AppTheme.shapes.pill),
                    tint = AppTheme.colors.onSurface,
                )
            }
            Column(
                modifier = Modifier.padding(AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                Text(
                    text = product.name.resolve(language),
                    style = AppTheme.typography.headlineLg,
                    color = AppTheme.colors.onSurface,
                )
                Text(
                    text = product.priceCents.formatCadCents(),
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.primary,
                )
                product.property?.let { PropertyFacts(it) }
                val description = product.description.resolve(language)
                if (!description.isNullOrBlank()) {
                    Text(text = description, style = AppTheme.typography.bodyMd, color = AppTheme.colors.onSurfaceVariant)
                }
                Text(text = state.businessName, style = AppTheme.typography.labelMd, color = AppTheme.colors.onSurfaceVariant)
                // Property listings are informational — you contact the business, you don't cart a house.
                if (product.property == null) {
                    QuantityStepper(quantity = state.quantity, onQuantityChange = onQuantity)
                }
                if (state.replacesCart) {
                    Text(
                        text = stringResource(Res.string.ord_replace_cart_warning),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onErrorContainer,
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(AppTheme.colors.errorContainer, AppTheme.shapes.md)
                            .padding(AppTheme.spacing.md),
                    )
                }
            }
        }
        if (product.property == null) {
            Column(modifier = Modifier.navigationBarsPadding().padding(AppTheme.spacing.lg), verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                AppButton(
                    text = stringResource(if (state.added) Res.string.ord_added else Res.string.ord_add_to_cart),
                    onClick = { if (state.replacesCart) showReplaceConfirm = true else onAddToCart() },
                    modifier = Modifier.fillMaxWidth(),
                    leadingIcon = if (state.added) "check" else "add_shopping_cart",
                    enabled = product.available,
                )
                if (state.added) {
                    AppButton(
                        text = stringResource(Res.string.ord_cart_title),
                        onClick = onOpenCart,
                        modifier = Modifier.fillMaxWidth(),
                        variant = AppButtonVariant.Secondary,
                        leadingIcon = "shopping_cart",
                    )
                }
            }
        }
    }
}

// ---------- Cart (Stitch ce45e69a — deviations: no promo code/rewards/shipping; pickup model) ----------

@Composable
fun CartRoute(
    onBack: () -> Unit,
    onCheckout: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: CartViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    CartScreen(
        state = state,
        onBack = onBack,
        onQuantity = viewModel::setQuantity,
        onRemove = viewModel::remove,
        onCheckout = onCheckout,
        modifier = modifier,
    )
}

@Composable
fun CartScreen(
    state: CartUiState,
    onBack: () -> Unit,
    onQuantity: (String, Int) -> Unit,
    onRemove: (String) -> Unit,
    onCheckout: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(modifier = modifier.fillMaxHeight().background(AppTheme.colors.background).appContentWidth(AppTheme.sizes.contentMaxWidthCompact)) {
        ScreenHeader(title = stringResource(Res.string.ord_cart_title), onBack = onBack)
        if (state.items.isEmpty()) {
            EmptyState(
                title = stringResource(Res.string.ord_cart_empty_title),
                description = stringResource(Res.string.ord_cart_empty_desc),
            )
            return
        }
        LazyColumn(
            modifier = Modifier.weight(1f),
            contentPadding = PaddingValues(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            item {
                Text(text = state.businessName, style = AppTheme.typography.labelMd, color = AppTheme.colors.onSurfaceVariant)
            }
            items(count = state.items.size, key = { state.items[it].productId }) { index ->
                val item = state.items[index]
                CartRow(item = item, onQuantity = { q -> onQuantity(item.productId, q) }, onRemove = { onRemove(item.productId) })
            }
        }
        Column(modifier = Modifier.navigationBarsPadding().padding(AppTheme.spacing.lg), verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            SummaryRow(label = stringResource(Res.string.ord_subtotal), value = state.subtotalCents.formatCadCents())
            Text(
                text = stringResource(Res.string.ord_pay_at_pickup),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
            )
            AppButton(
                text = stringResource(Res.string.ord_proceed_checkout),
                onClick = onCheckout,
                modifier = Modifier.fillMaxWidth(),
                trailingIcon = "arrow_forward",
            )
        }
    }
}

@Composable
private fun CartRow(item: CartItem, onQuantity: (Int) -> Unit, onRemove: () -> Unit) {
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier.padding(AppTheme.spacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs)) {
                Text(text = item.name, style = AppTheme.typography.bodyLg, color = AppTheme.colors.onSurface)
                Text(
                    text = item.lineTotalCents.formatCadCents(),
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.primary,
                )
            }
            QuantityStepper(quantity = item.quantity, onQuantityChange = onQuantity)
            AppIconButton(
                iconName = "delete",
                contentDescription = stringResource(Res.string.ord_cart_remove_a11y),
                onClick = onRemove,
                tint = AppTheme.colors.onSurfaceVariant,
            )
        }
    }
}

// ---------- Checkout (Stitch f140cdc2 — pickup: no shipping/payment steps, no fake totals) ----------

@Composable
fun CheckoutRoute(
    onBack: () -> Unit,
    onPlaced: (orderId: String) -> Unit,
    onRequireSignIn: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: CheckoutViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    LaunchedEffect(state.placedOrderId, state.signInRequired) {
        state.placedOrderId?.let { viewModel.consumeGates(); onPlaced(it) }
        if (state.signInRequired) { viewModel.consumeGates(); onRequireSignIn() }
    }
    CheckoutScreen(state = state, onBack = onBack, onPlace = viewModel::placeOrder, modifier = modifier)
}

@Composable
fun CheckoutScreen(
    state: CheckoutUiState,
    onBack: () -> Unit,
    onPlace: (note: String) -> Unit,
    modifier: Modifier = Modifier,
) {
    var note by remember { mutableStateOf("") }
    Column(modifier = modifier.fillMaxHeight().background(AppTheme.colors.background).appContentWidth(AppTheme.sizes.contentMaxWidthCompact)) {
        ScreenHeader(title = stringResource(Res.string.ord_checkout_title), onBack = onBack)
        Column(
            modifier = Modifier.weight(1f).verticalScroll(rememberScrollState()).padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            state.items.forEach { item ->
                SummaryRow(label = stringResource(Res.string.ord_qty_line, item.quantity, item.name), value = item.lineTotalCents.formatCadCents())
            }
            SummaryRow(label = stringResource(Res.string.ord_subtotal), value = state.subtotalCents.formatCadCents(), emphasized = true)
            Text(
                text = stringResource(Res.string.ord_checkout_pickup_note),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.md)
                    .padding(AppTheme.spacing.md),
            )
            AppTextField(
                value = note,
                onValueChange = { note = it },
                label = stringResource(Res.string.ord_checkout_note_label),
                modifier = Modifier.fillMaxWidth(),
            )
            if (state.failed) {
                Text(
                    text = stringResource(Res.string.ord_checkout_failed),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onErrorContainer,
                )
            }
        }
        AppButton(
            text = stringResource(Res.string.ord_checkout_cta),
            onClick = { onPlace(note) },
            modifier = Modifier.fillMaxWidth().navigationBarsPadding().padding(AppTheme.spacing.lg),
            enabled = state.items.isNotEmpty() && !state.placing,
            loading = state.placing,
            leadingIcon = "storefront",
        )
    }
}

// ---------- Confirmation (d3f50950) + history (4d08fbb9) ----------

@Composable
fun OrderConfirmationRoute(
    orderId: String,
    onDone: () -> Unit,
    onViewOrders: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: OrderConfirmationViewModel = koinViewModel(parameters = { parametersOf(orderId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    Column(
        modifier = modifier.fillMaxHeight().background(AppTheme.colors.background)
            .appContentWidth(AppTheme.sizes.contentMaxWidthCompact)
            .statusBarsPadding().navigationBarsPadding().padding(AppTheme.spacing.lg),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        when {
            state.loading -> LoadingState()
            state.error || state.order == null -> ErrorState(
                message = stringResource(Res.string.ord_error),
                onRetry = onDone,
                retryLabel = stringResource(Res.string.ord_retry),
            )
            else -> {
                val order = state.order ?: return
                AppIcon(name = "check_circle", size = AppTheme.sizes.iconHero, tint = AppTheme.colors.primary)
                Text(
                    text = stringResource(Res.string.ord_confirm_title),
                    style = AppTheme.typography.headlineLg,
                    color = AppTheme.colors.onSurface,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.padding(top = AppTheme.spacing.md),
                )
                Text(
                    text = stringResource(Res.string.ord_confirm_desc, order.businessName, order.totalCents.formatCadCents()),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.padding(top = AppTheme.spacing.sm),
                )
                AppButton(
                    text = stringResource(Res.string.ord_view_orders),
                    onClick = onViewOrders,
                    modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.lg),
                )
                AppButton(
                    text = stringResource(Res.string.ord_retry),
                    onClick = onDone,
                    modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.sm),
                    variant = AppButtonVariant.Secondary,
                )
            }
        }
    }
}

@Composable
fun OrderHistoryRoute(
    onBack: () -> Unit,
    onRequireSignIn: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: OrderHistoryViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    LaunchedEffect(state.signInRequired) {
        if (state.signInRequired) onRequireSignIn()
    }
    Column(modifier = modifier.fillMaxHeight().background(AppTheme.colors.background).appContentWidth(AppTheme.sizes.contentMaxWidth)) {
        ScreenHeader(title = stringResource(Res.string.ord_history_title), onBack = onBack)
        when {
            state.loading -> LoadingState()
            state.error -> ErrorState(
                message = stringResource(Res.string.ord_error),
                onRetry = onBack,
                retryLabel = stringResource(Res.string.ord_retry),
            )
            state.orders.isEmpty() -> EmptyState(
                title = stringResource(Res.string.ord_history_empty_title),
                description = stringResource(Res.string.ord_history_empty_desc),
            )
            else -> LazyColumn(
                contentPadding = PaddingValues(AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                items(count = state.orders.size, key = { state.orders[it].id }) { index ->
                    val order = state.orders[index]
                    OrderRow(
                        order = order,
                        busy = order.id in state.busyIds,
                        cancelFailed = order.id in state.failedIds,
                        onCancel = { viewModel.cancel(order.id) },
                    )
                }
            }
        }
    }
}

@Composable
private fun OrderRow(
    order: Order,
    busy: Boolean = false,
    cancelFailed: Boolean = false,
    onCancel: (() -> Unit)? = null,
) {
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(modifier = Modifier.padding(AppTheme.spacing.lg), verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(text = order.businessName, style = AppTheme.typography.bodyLg, color = AppTheme.colors.onSurface)
                StatusBadge(
                    label = stringResource(
                        when (order.status) {
                            OrderStatus.Pending -> Res.string.ord_status_pending
                            OrderStatus.Confirmed -> Res.string.ord_status_confirmed
                            OrderStatus.Fulfilled -> Res.string.ord_status_fulfilled
                            OrderStatus.Cancelled -> Res.string.ord_status_cancelled
                        },
                    ),
                )
            }
            order.createdAtMillis?.let { millis ->
                Text(
                    text = orderTimeLabel(millis),
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
            order.items.forEach { item ->
                Text(
                    text = stringResource(Res.string.ord_qty_line, item.quantity, item.name),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
            SummaryRow(label = stringResource(Res.string.ord_subtotal), value = order.totalCents.formatCadCents(), emphasized = true)
            // Buyer may cancel only while the business hasn't confirmed yet (rules enforce it too).
            if (onCancel != null && order.status == OrderStatus.Pending) {
                var confirmCancel by remember(order.id) { mutableStateOf(false) }
                if (cancelFailed) {
                    Text(
                        text = stringResource(Res.string.ord_cancel_failed),
                        style = AppTheme.typography.labelSm,
                        color = AppTheme.colors.error,
                    )
                }
                AppButton(
                    text = stringResource(Res.string.ord_cancel_order),
                    onClick = { confirmCancel = true },
                    variant = AppButtonVariant.Secondary,
                    enabled = !busy,
                    loading = busy,
                    modifier = Modifier.fillMaxWidth(),
                )
                if (confirmCancel) {
                    AppConfirmDialog(
                        title = stringResource(Res.string.ord_cancel_order),
                        message = stringResource(Res.string.ord_cancel_confirm_message),
                        confirmLabel = stringResource(Res.string.ord_cancel_order),
                        cancelLabel = stringResource(Res.string.ord_cancel_keep),
                        destructive = true,
                        onConfirm = {
                            confirmCancel = false
                            onCancel()
                        },
                        onDismiss = { confirmCancel = false },
                    )
                }
            }
        }
    }
}

// ---------- Manage products (owner/dashboard side) ----------

@Composable
fun ManageProductsRoute(
    businessId: String,
    onBack: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: ManageProductsViewModel = koinViewModel(parameters = { parametersOf(businessId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    var nameEn by remember { mutableStateOf("") }
    var nameFa by remember { mutableStateOf("") }
    var price by remember { mutableStateOf("") }
    var promoted by remember { mutableStateOf(false) }
    var propertyListing by remember { mutableStateOf(false) }
    var propBeds by remember { mutableStateOf("") }
    var propBaths by remember { mutableStateOf("") }
    var propArea by remember { mutableStateOf("") }
    var propAddress by remember { mutableStateOf("") }

    Column(modifier = modifier.fillMaxHeight().background(AppTheme.colors.background).appContentWidth(AppTheme.sizes.contentMaxWidth)) {
        ScreenHeader(title = stringResource(Res.string.ord_mp_title), onBack = onBack)
        LazyColumn(
            contentPadding = PaddingValues(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            item {
                AppCard(modifier = Modifier.fillMaxWidth()) {
                    Column(modifier = Modifier.padding(AppTheme.spacing.lg), verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                        AppTextField(value = nameEn, onValueChange = { nameEn = it }, label = stringResource(Res.string.ord_mp_name_en), modifier = Modifier.fillMaxWidth())
                        AppTextField(value = nameFa, onValueChange = { nameFa = it }, label = stringResource(Res.string.ord_mp_name_fa), modifier = Modifier.fillMaxWidth())
                        AppTextField(value = price, onValueChange = { price = it.filter { c -> c.isDigit() || c == '.' } }, label = stringResource(Res.string.ord_mp_price), modifier = Modifier.fillMaxWidth())
                        SettingsToggleRow(
                            iconName = "local_offer",
                            title = stringResource(Res.string.ord_mp_promoted_title),
                            subtitle = stringResource(Res.string.ord_mp_promoted_desc),
                            checked = promoted,
                            onCheckedChange = { promoted = it },
                        )
                        SettingsToggleRow(
                            iconName = "home_work",
                            title = stringResource(Res.string.ord_prop_toggle_title),
                            subtitle = stringResource(Res.string.ord_prop_toggle_desc),
                            checked = propertyListing,
                            onCheckedChange = { propertyListing = it },
                        )
                        if (propertyListing) {
                            AppTextField(value = propBeds, onValueChange = { propBeds = it.filter(Char::isDigit) }, label = stringResource(Res.string.ord_prop_bedrooms), modifier = Modifier.fillMaxWidth())
                            AppTextField(value = propBaths, onValueChange = { propBaths = it.filter { c -> c.isDigit() || c == '.' } }, label = stringResource(Res.string.ord_prop_bathrooms), modifier = Modifier.fillMaxWidth())
                            AppTextField(value = propArea, onValueChange = { propArea = it.filter(Char::isDigit) }, label = stringResource(Res.string.ord_prop_area), modifier = Modifier.fillMaxWidth())
                            AppTextField(value = propAddress, onValueChange = { propAddress = it }, label = stringResource(Res.string.ord_prop_address), modifier = Modifier.fillMaxWidth())
                        }
                        AppButton(
                            text = stringResource(Res.string.ord_mp_add),
                            onClick = {
                                // Round, don't truncate: 19.99*100 is 1998.999… in float → toLong()
                                // gave 1998 ($19.98). Mirrors the Add-Business fix.
                                val cents = price.toDoubleOrNull()?.let { (it * 100).roundToLong() } ?: 0L
                                val property = if (propertyListing) {
                                    PropertyDetails(
                                        bedrooms = propBeds.toIntOrNull(),
                                        bathrooms = propBaths.toDoubleOrNull(),
                                        areaSqFt = propArea.toIntOrNull(),
                                        address = propAddress.trim().ifEmpty { null },
                                    ).takeIf { it.hasAnyFact }
                                } else null
                                viewModel.save(null, nameEn, nameFa, cents, available = true, promoted = promoted, property = property)
                                nameEn = ""; nameFa = ""; price = ""; promoted = false
                                propertyListing = false; propBeds = ""; propBaths = ""; propArea = ""; propAddress = ""
                            },
                            modifier = Modifier.fillMaxWidth(),
                            enabled = nameEn.isNotBlank() && (price.toDoubleOrNull() ?: 0.0) > 0 && !state.saving,
                            loading = state.saving,
                            leadingIcon = "add",
                        )
                        if (state.saveFailed) {
                            Text(
                                text = stringResource(Res.string.orders_product_save_failed),
                                style = AppTheme.typography.bodySm,
                                color = AppTheme.colors.onErrorContainer,
                            )
                        }
                    }
                }
            }
            if (state.loading) {
                item { LoadingState() }
            } else {
                items(count = state.products.size, key = { state.products[it].id }) { index ->
                    val product = state.products[index]
                    AppCard(modifier = Modifier.fillMaxWidth()) {
                        Row(
                            modifier = Modifier.padding(AppTheme.spacing.md).fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Column {
                                Text(text = product.name.resolve(AppTheme.language), style = AppTheme.typography.bodyLg, color = AppTheme.colors.onSurface)
                                Text(text = product.priceCents.formatCadCents(), style = AppTheme.typography.labelMd, color = AppTheme.colors.primary)
                            }
                            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
                                if (product.promoted) {
                                    StatusBadge(label = stringResource(Res.string.ord_mp_promoted))
                                }
                                if (product.available) {
                                    StatusBadge(label = stringResource(Res.string.ord_mp_available))
                                }
                            }
                        }
                        AppButton(
                            text = stringResource(
                                if (product.promoted) Res.string.ord_mp_remove_promotion else Res.string.ord_mp_mark_promoted,
                            ),
                            onClick = {
                                viewModel.save(
                                    product.id,
                                    product.name.en.orEmpty(),
                                    product.name.fa.orEmpty(),
                                    product.priceCents,
                                    product.available,
                                    promoted = !product.promoted,
                                    nameFr = product.name.fr.orEmpty(),
                                    description = product.description,
                                    property = product.property,
                                )
                            },
                            modifier = Modifier.fillMaxWidth().padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.sm),
                            variant = AppButtonVariant.Secondary,
                            leadingIcon = if (product.promoted) "remove_circle" else "local_offer",
                            enabled = !state.saving,
                        )
                    }
                }
            }
        }
    }
}

// ---------- Shared bits ----------

@Composable
private fun ScreenHeader(title: String, onBack: () -> Unit) {
    Row(
        // Pushed full-screen routes draw edge-to-edge; keep the header out of the status bar.
        modifier = Modifier.fillMaxWidth().statusBarsPadding().navigationBarsPadding().padding(AppTheme.spacing.lg),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        AppIconButton(
            iconName = "arrow_back",
            contentDescription = stringResource(Res.string.ord_back_a11y),
            onClick = onBack,
            tint = AppTheme.colors.onSurface,
        )
        Text(text = title, style = AppTheme.typography.headlineLg, color = AppTheme.colors.onSurface)
    }
}

@Composable
private fun SummaryRow(label: String, value: String, emphasized: Boolean = false) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
    ) {
        Text(
            text = label,
            style = if (emphasized) AppTheme.typography.bodyLg else AppTheme.typography.bodyMd,
            color = AppTheme.colors.onSurface,
        )
        Text(
            text = value,
            style = if (emphasized) AppTheme.typography.headlineMd else AppTheme.typography.bodyMd,
            color = if (emphasized) AppTheme.colors.primary else AppTheme.colors.onSurface,
        )
    }
}

/** Promotions rail for the business detail screen (rendered by :feature:business via the shell). */
@Composable
fun PromotionsSection(
    businessId: String,
    onProductClick: (productId: String) -> Unit,
    modifier: Modifier = Modifier,
    viewModel: ManageProductsViewModel = koinViewModel(parameters = { parametersOf(businessId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val promoted = state.products.filter { it.available && it.promoted }
    if (state.loading || promoted.isEmpty()) return
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
        SectionHeader(title = stringResource(Res.string.ord_promotions_section_title))
        LazyRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
            items(count = promoted.size, key = { promoted[it].id }) { index ->
                ProductSummaryCard(
                    product = promoted[index],
                    badgeLabel = stringResource(Res.string.ord_mp_promoted),
                    onClick = { onProductClick(promoted[index].id) },
                    modifier = Modifier.width(AppTheme.sizes.compactItemCardWidth),
                )
            }
        }
    }
}

/**
 * Two-column listings grid for the bottom of the business detail screen. Promoted items live in
 * [PromotionsSection]; this shows the rest of the catalog (everything when nothing is promoted).
 */
@Composable
fun ProductListingsSection(
    businessId: String,
    onProductClick: (productId: String) -> Unit,
    modifier: Modifier = Modifier,
    viewModel: ManageProductsViewModel = koinViewModel(parameters = { parametersOf(businessId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val listings = state.products.filter { it.available && !it.promoted }
    if (state.loading || listings.isEmpty()) return
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
        SectionHeader(title = stringResource(Res.string.ord_products_section_title))
        listings.chunked(2).forEach { row ->
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                row.forEach { product ->
                    ProductSummaryCard(
                        product = product,
                        onClick = { onProductClick(product.id) },
                        modifier = Modifier.weight(1f),
                    )
                }
                if (row.size == 1) {
                    Box(modifier = Modifier.weight(1f))
                }
            }
        }
    }
}

@Composable
private fun ProductSummaryCard(
    product: Product,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    badgeLabel: String? = null,
) {
    AppCard(modifier = modifier, onClick = onClick) {
        Column {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .aspectRatio(4f / 3f),
                contentAlignment = Alignment.TopStart,
            ) {
                BusinessCover(
                    imageUrl = product.imageUrl,
                    contentDescription = stringResource(Res.string.ord_product_image_a11y),
                    iconName = "sell",
                )
                if (badgeLabel != null) {
                    StatusBadge(
                        label = badgeLabel,
                        modifier = Modifier.padding(AppTheme.spacing.sm),
                    )
                }
            }
            Column(
                modifier = Modifier.padding(AppTheme.spacing.md),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
            ) {
                Text(
                    text = product.name.resolve(AppTheme.language),
                    style = AppTheme.typography.bodyLg,
                    color = AppTheme.colors.onSurface,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                )
                Text(
                    text = product.priceCents.formatCadCents(),
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.primary,
                )
                val facts = product.property?.let { p ->
                    buildList {
                        p.bedrooms?.let { add(stringResource(Res.string.ord_prop_beds_short, it)) }
                        p.bathrooms?.let { add(stringResource(Res.string.ord_prop_baths_short, it.formatBathCount())) }
                        p.areaSqFt?.let { add(stringResource(Res.string.ord_prop_sqft_short, it.toString())) }
                    }
                }.orEmpty()
                if (facts.isNotEmpty()) {
                    Text(
                        text = facts.joinToString(" · "),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onSurfaceVariant,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
            }
        }
    }
}

/** Real-estate facts (beds/baths/area + address) shown on property-style listings. */
@Composable
private fun PropertyFacts(property: PropertyDetails) {
    Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
        Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg)) {
            property.bedrooms?.let {
                PropertyFact("bed", stringResource(Res.string.ord_prop_beds_short, it))
            }
            property.bathrooms?.let {
                PropertyFact("bathtub", stringResource(Res.string.ord_prop_baths_short, it.formatBathCount()))
            }
            property.areaSqFt?.let {
                PropertyFact("square_foot", stringResource(Res.string.ord_prop_sqft_short, it.toString()))
            }
        }
        property.address?.let { PropertyFact("location_on", it) }
    }
}

@Composable
private fun PropertyFact(iconName: String, text: String) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
    ) {
        AppIcon(name = iconName, size = AppTheme.sizes.iconSm, tint = AppTheme.colors.primary)
        Text(text = text, style = AppTheme.typography.bodyMd, color = AppTheme.colors.onSurface)
    }
}

/** "2.5" baths keeps its half; whole counts drop the trailing ".0". */
private fun Double.formatBathCount(): String =
    if (this % 1.0 == 0.0) toInt().toString() else toString()

// ---------- Manage orders (owner/dashboard side) ----------

/** Stateful entry for the owner's order inbox (one business). */
@Composable
fun ManageOrdersRoute(
    businessId: String,
    onBack: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: ManageOrdersViewModel = koinViewModel(parameters = { parametersOf(businessId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    Column(modifier = modifier.fillMaxHeight().background(AppTheme.colors.background).appContentWidth(AppTheme.sizes.contentMaxWidth)) {
        ScreenHeader(title = stringResource(Res.string.ord_mo_title), onBack = onBack)
        when {
            state.loading -> LoadingState()
            state.error -> ErrorState(
                message = stringResource(Res.string.ord_mo_error),
                onRetry = onBack,
                retryLabel = stringResource(Res.string.ord_mo_retry),
            )
            state.orders.isEmpty() -> EmptyState(
                title = stringResource(Res.string.ord_mo_empty_title),
                description = stringResource(Res.string.ord_mo_empty_desc),
            )
            else -> LazyColumn(
                contentPadding = PaddingValues(AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                items(count = state.orders.size, key = { state.orders[it].id }) { index ->
                    val order = state.orders[index]
                    OwnerOrderRow(
                        order = order,
                        busy = order.id in state.busyIds,
                        failed = order.id in state.failedIds,
                        onMove = { status, payment -> viewModel.move(order.id, status, payment) },
                    )
                }
            }
        }
    }
}

/**
 * One order in the owner inbox: lines + note + total, then the legal next moves for its status
 * (rules enforce the same machine server-side, so a stale button can't corrupt anything).
 */
@Composable
private fun OwnerOrderRow(
    order: Order,
    busy: Boolean,
    failed: Boolean,
    onMove: (OrderStatus?, PaymentStatus?) -> Unit,
) {
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(modifier = Modifier.padding(AppTheme.spacing.lg), verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(
                    text = order.totalCents.formatCadCents(),
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSurface,
                )
                Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
                    if (order.paymentStatus == PaymentStatus.Paid) {
                        StatusBadge(label = stringResource(Res.string.ord_mo_paid))
                    }
                    StatusBadge(
                        label = stringResource(
                            when (order.status) {
                                OrderStatus.Pending -> Res.string.ord_status_pending
                                OrderStatus.Confirmed -> Res.string.ord_status_confirmed
                                OrderStatus.Fulfilled -> Res.string.ord_status_fulfilled
                                OrderStatus.Cancelled -> Res.string.ord_status_cancelled
                            },
                        ),
                    )
                }
            }
            order.items.forEach { item ->
                Text(
                    text = stringResource(Res.string.ord_qty_line, item.quantity, item.name),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
            if (order.note.isNotBlank()) {
                Text(
                    text = stringResource(Res.string.ord_mo_note, order.note),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
            if (failed) {
                Text(
                    text = stringResource(Res.string.ord_mo_failed),
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.error,
                )
            }
            when (order.status) {
                OrderStatus.Pending -> {
                    AppButton(
                        text = stringResource(Res.string.ord_mo_accept),
                        onClick = { onMove(OrderStatus.Confirmed, null) },
                        enabled = !busy,
                        loading = busy,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    OwnerCancelButton(busy = busy, onConfirmed = { onMove(OrderStatus.Cancelled, null) })
                }
                OrderStatus.Confirmed -> {
                    // Pay-at-pickup: handing the order over and getting paid happen together.
                    AppButton(
                        text = stringResource(Res.string.ord_mo_fulfill),
                        onClick = { onMove(OrderStatus.Fulfilled, PaymentStatus.Paid) },
                        enabled = !busy,
                        loading = busy,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    OwnerCancelButton(busy = busy, onConfirmed = { onMove(OrderStatus.Cancelled, null) })
                }
                OrderStatus.Fulfilled, OrderStatus.Cancelled -> Unit
            }
        }
    }
}

/** Relative "placed N ago" label for an order row; bucketed to the largest sensible unit. */
@Composable
private fun orderTimeLabel(millis: Long): String {
    val minutes = ((Clock.System.now().toEpochMilliseconds() - millis) / 60_000L).coerceAtLeast(0)
    val lang = AppTheme.language
    return when {
        minutes < 1 -> stringResource(Res.string.ord_time_just_now)
        minutes < 60 -> stringResource(Res.string.ord_time_minutes_ago, lang.formatCount(minutes))
        minutes < 60 * 24 -> stringResource(Res.string.ord_time_hours_ago, lang.formatCount(minutes / 60))
        minutes < 60 * 24 * 7 -> stringResource(Res.string.ord_time_days_ago, lang.formatCount(minutes / (60 * 24)))
        else -> stringResource(Res.string.ord_time_weeks_ago, lang.formatCount(minutes / (60 * 24 * 7)))
    }
}

@Composable
private fun OwnerCancelButton(busy: Boolean, onConfirmed: () -> Unit) {
    var confirm by remember { mutableStateOf(false) }
    AppButton(
        text = stringResource(Res.string.ord_cancel_order),
        onClick = { confirm = true },
        variant = AppButtonVariant.Secondary,
        enabled = !busy,
        modifier = Modifier.fillMaxWidth(),
    )
    if (confirm) {
        AppConfirmDialog(
            title = stringResource(Res.string.ord_cancel_order),
            message = stringResource(Res.string.ord_mo_cancel_message),
            confirmLabel = stringResource(Res.string.ord_cancel_order),
            cancelLabel = stringResource(Res.string.ord_cancel_keep),
            destructive = true,
            onConfirm = {
                confirm = false
                onConfirmed()
            },
            onDismiss = { confirm = false },
        )
    }
}
